import {RootState} from '../../types/redux';

export const getViewer = (state: RootState) => {
  return state.viewer.viewer;
};
